import React from 'react';
import { Redirect } from 'react-router-dom';
import { routePaths } from 'js/components/router/route-paths';

const ChequeRunRedirect = () => {
  return <Redirect to={routePaths.chequeRunCurrent} />;
};

export default ChequeRunRedirect;
